var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown-user-sp"},[_c('li',[_c('button',{on:{"click":function($event){return _vm.$emit("emitClickLogout")}}},[_vm._v(" ログアウト ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }